export const DayParamValues = [
    {
        value: 0,
        label: "Bieżący dzień"
    },
    {
        value: 1,
        label: "Poprzedni dzień"
    }
];

export const RangeParamValues = [
    {
        value: 0,
        label: "Bieżący miesiąc"
    },
    {
        value: 1,
        label: "Poprzedni miesiąc"
    }
];

export const parseDistributionParams = (params) => {
    if (!params) return {};
    if (typeof params === 'object') return params;
    try {
        return JSON.parse(params);
    } catch (e) {
        return {};
    }
}

export const getSelectableIdValue = (value) => {
    if (!value) return null;
    if (typeof value === 'object') {
        return value.id || null;
    }
    return value;
}

export const getLocationIdValue = (value) => {
    return getSelectableIdValue(value);
}

export const getPrinterIdValue = (value) => {
    return getSelectableIdValue(value);
}

export const hasSelectableValue = (value) => getSelectableIdValue(value) != null;

export const toLocationOption = (location) => {
    if (!location) return null;
    if (typeof location !== 'object') {
        return {
            id: location,
            label: String(location),
        };
    }
    return {
        ...location,
        label: location.label || location.path || location.name || (location.id ? `Lokacja ${location.id}` : ''),
    };
}

export const formatPrinterLabel = (printer) => {
    if (!printer) return '';
    const parts = [];
    const title = printer.name || printer.model || printer.serialNumber || printer.nis;
    if (title) parts.push(title);
    if (printer.serialNumber) parts.push(`SN: ${printer.serialNumber}`);
    if (printer.nis) parts.push(`NIS: ${printer.nis}`);
    if (printer.location) parts.push(printer.location);
    return parts.join(' | ') || (printer.id ? `Urządzenie ${printer.id}` : 'Urządzenie');
}

export const toPrinterOption = (printer) => {
    if (!printer) return null;
    if (typeof printer !== 'object') {
        return {
            id: printer,
            label: `Urządzenie ${printer}`,
        };
    }
    return {
        ...printer,
        label: printer.label || formatPrinterLabel(printer),
    };
}

export const getRangeLabel = (reportId, range) => {
    const options = reportId === 'counters_day' ? DayParamValues : RangeParamValues;
    const selected = options.find(o => Number(o.value) === Number(range));
    return selected ? selected.label : '[brak]';
}

export const formatDistributionParams = (reportId, params, {locationLabel, printerLabel, multiline = false} = {}) => {
    switch (reportId) {
        case 'counters_day':
        case 'counters_range':
        case 'consumables_range': {
            const locationId = getLocationIdValue(params.locationId);
            const printerId = getPrinterIdValue(params.printerId);
            const lines = [
                `Zakres: ${getRangeLabel(reportId, params.range)}`,
                printerId != null
                    ? `Urządzenie: ${printerLabel || `ID ${printerId}`}`
                    : locationId != null
                        ? `Lokacja: ${locationLabel || `ID ${locationId}`}`
                        : 'Filtrowanie: wszystkie urządzenia'
            ];
            return lines.join(multiline ? '\n' : ' | ');
        }
        default:
            return 'Brak parametrów';
    }
}

